<template>
  <div class="content-box-black-board" v-if="show">
    <div class="content bg">
      <img v-if="!isDesktop" class="img-title" :src="require(`../assets/${targetFolder}/blackboard/black_board_title.png`)" />
      <div class="specific bg">
        <img @click="closeDialog" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" />
        <div @click="carouselClick">
          <swiper
              ref="blackboard"
              :options="options.blackboard" >
              <swiper-slide v-for="item in list" :key="item.id" >
                <img
                  :data-url="item.url"
                  :src="item.pc" />
              </swiper-slide>
              <div
                class="swiper-pagination carousel-pagination"
                slot="pagination"></div>
          </swiper>
        </div>
        <img class="prev" @click="swiperPrev" :src="require(`../assets/${targetFolder}/blackboard/prev.png`)" />
        <img class="next" @click="swiperNext" :src="require(`../assets/${targetFolder}/blackboard/next.png`)" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWebSiteContent
} from '@/api'
export default {
  name: 'BlackBoard',
  data () {
    return {
      show: false,
      options: {
        blackboard: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 5000
          // },
          loop: true
        }
      },
      list: []
    }
  },
  computed: {
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    }
  },
  watch: {
  },
  mounted () {

  },
  created () {
    require(`../styles/${this.targetFolder}/blackboard.scss`)
  },
  methods: {
    closeDialog () {
      this.show = false
      this.$emit('closeDialog')
    },
    swiperPrev () {
      this.$refs.blackboard.$swiper.slidePrev()
    },
    swiperNext () {
      this.$refs.blackboard.$swiper.slideNext()
    },
    carouselClick (e) {
      const target = e.target
      if (target.nodeName === 'IMG') {
        location.href = target.getAttribute('data-url')
        // window.open(target.getAttribute('data-url'))
      }
    },
    // 新版官网获取数据
    async getWebSiteContent () {
      try {
        const params = {
          type: 5
        }
        const { data } = await getWebSiteContent(params)
        this.list = data
        // console.log(this.list)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
